import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router';
import App from './App';
import { ThemeModeProvider } from './theme/ThemeContext';
import './services/tokenRefresh';
import './global.css';
import './index.css';
import { APPLICATION_LOCAL_STORAGE } from './common/constants/constants';

// Extract ping access token from URL if present (supports both access_token and access-token)
const url = window.location.href;
console.log('main.tsx: Current URL is:', url);
const tokenMatch = url.match(/(?:#access[-_]token)=([^&]+)/);
if (tokenMatch && tokenMatch[1]) {
  const token = tokenMatch[1];
  console.log(
    'main.tsx: Found access token in URL, storing to localStorage:',
    token.substring(0, 15) + '...'
  );
  localStorage.setItem(APPLICATION_LOCAL_STORAGE.PING_ACCESS_TOKEN, token);
  // Redirect to login page to trigger authentication if not already there
  if (!window.location.pathname.startsWith('/login')) {
    console.log('main.tsx: Redirecting to /login to trigger authentication...');
    window.location.replace('/login');
  }
} else {
  console.log('main.tsx: No access token found in URL matching regex.');
}

import { ModuleRegistry, AllCommunityModule } from 'ag-grid-community';

// Import AG Grid legacy CSS styles
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';

// react-date-range calendar layout (required — without these, calendar has no grid)
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';

// Register AG Grid Community modules
ModuleRegistry.registerModules([AllCommunityModule]);

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <ThemeModeProvider>
    <Router
    // future={{
    //   v7_startTransition: true,
    //   v7_relativeSplatPath: true,
    // }}
    >
      <App />
    </Router>
  </ThemeModeProvider>
);
